import { Offsets, DockPosition } from "./notification.class";

export class NotificationConfig {
	waitTimes?: {
		default: number;
		info?: number;
		busy?: number;
		error?: number;
		warning?: number;
	};
	autoCloseErrors?: boolean;
	position?: DockPosition;
	offsets?: Offsets;
}
